$(() =>
  $('.js-chosen-topics').chosen({
    placeholder_text_multiple: '--Please select--',
    single_backstroke_delete: false,
    inherit_select_classes: true,
    width: '100%'
  })
);
